module.exports = __webpack_public_path__ + "site/img/119.0b625b2a.jpg";